export enum QuestionTypes {
  RESPONSE_FIELD = 'RESPONSE_FIELD',
  DATE_PICKER = 'DATE_PICKER',
  DATE = 'DATE',
  RADIO_BUTTONS = 'RADIO_BUTTONS',
  DROPDOWN = 'DROPDOWN',
  LIST = 'LIST',
  ACCESSORY = 'Accessory',
}
